import React, { useEffect } from 'react';
import { ModuleBridge, TopActionBar, ReportDateRangePicker } from '../components';

export const ReportingMigrationStatus = () => {
    return (
        <>
            <TopActionBar>
                <ReportDateRangePicker />
            </TopActionBar>
            <div id="backbone_reporting_wrapper"></div>
            <ModuleBridge moduleId="reporting_migration_status_module" />
        </>
    );
};
